import { useEffect, useCallback } from 'react';
import { PostMessage } from '../../../message-service';
import { globalConfig } from '../../../shared/config/config';

function IsJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const actions = [
  globalConfig.postMessage.actions.editorPersonalizationChanged,
  globalConfig.postMessage.actions.editorOpenedPublicPost,
  globalConfig.postMessage.actions.editorOpenedPopup,

  globalConfig.postMessage.actions.closePopup,
  globalConfig.postMessage.actions.publicPostSubmitted,
  globalConfig.postMessage.actions.reviewSubmitted,
  globalConfig.postMessage.actions.popupLoaded,
  globalConfig.postMessage.actions.updatePopupData,
  globalConfig.postMessage.actions.changePostPopup,
  globalConfig.postMessage.actions.fetchInfiniteScroll,
  globalConfig.postMessage.actions.recordEmbedLocation,
  globalConfig.postMessage.actions.recordEmbedViewed,
  globalConfig.postMessage.actions.tintAnalyticsScriptLoaded,
];

const usePostMessageListener = (callback: (data: PostMessage) => void) => {
  const memoizedOnReceiveMessage = useCallback(
    (event: MessageEvent) => {
      if (
        IsJsonString(event.data) &&
        (event.data.indexOf(globalConfig.postMessage.actions.closePopup) !== -1 ||
          event.data.indexOf(globalConfig.postMessage.actions.publicPostSubmitted) !== -1 ||
          event.data.indexOf(globalConfig.postMessage.actions.reviewSubmitted) !== -1 ||
          event.data.indexOf(globalConfig.postMessage.actions.changePostPopup) !== -1 ||
          event.data.indexOf(globalConfig.postMessage.actions.updatePopupData) !== -1 ||
          event.data.indexOf(globalConfig.postMessage.actions.popupLoaded) !== -1)
      ) {
        const data = JSON.parse(event.data);
        if (callback) {
          callback(data);
        }
      }
      if (event.data && actions.includes(event.data.type)) {
        if (callback) {
          callback(event.data);
        }
      }
    },
    [callback]
  );

  useEffect(() => {
    window.addEventListener('message', memoizedOnReceiveMessage, false);
    return () => {
      window.removeEventListener('message', memoizedOnReceiveMessage, false);
    };
  }, [memoizedOnReceiveMessage]);
};

export default usePostMessageListener;
